import axios from 'axios';

const casesService = {
  getCases: async (tenant, startDate, endDate) => {
    try {
      const params = { tenant };
      if (startDate) {
        params.start_date = startDate; // Expects YYYY-MM-DD
      }
      if (endDate) {
        params.end_date = endDate; // Expects YYYY-MM-DD
      }
      const response = await axios.get('/api/v1/cases_proxy', { params });
      return response.data; // The proxy already returns the data from the AlldoQ API
    } catch (error) {
      console.error('Error fetching cases:', error.response || error.message);
      // Throw a more specific error or handle it as needed by the component
      let errorMessage = 'Failed to fetch cases.';
      if (error.response && error.response.data) {
        if (error.response.data.errors && error.response.data.errors.date) {
          errorMessage = `Invalid date format: ${error.response.data.details.reason}`;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        }
      }
      throw new Error(errorMessage);
    }
  },
};

export default casesService; 